import AgencyManageAccoutInfo from './components/AgencyManageAccoutInfo.js';
import connect from './connect';
import './assets/AgencyManageAccoutInfo.css';

export default connect(AgencyManageAccoutInfo);



// WEBPACK FOOTER //
// ./src/routes/AgencyManageAccoutInfo/index.js